module.exports = __webpack_public_path__ + "img/icon10.f981ec54.png";